// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__NR5K5","title":"BackImages_title__JC_mZ","images":"BackImages_images__1DM9e"};